var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHindi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 8.3335H0.5V39.6668H47.5V8.3335Z",
    fill: "#FF9933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 18.7778H0.5V29.2223H47.5V18.7778Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 29.2222H0.5V39.6666H47.5V29.2222Z",
    fill: "#128807"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.1778C26.3074 28.1778 28.1778 26.3074 28.1778 24C28.1778 21.6927 26.3074 19.8223 24 19.8223C21.6927 19.8223 19.8223 21.6927 19.8223 24C19.8223 26.3074 21.6927 28.1778 24 28.1778Z",
    fill: "#000088"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 27.6556C26.0192 27.6556 27.6558 26.0189 27.6558 24C27.6558 21.9811 26.0192 20.3445 24.0003 20.3445C21.9814 20.3445 20.3447 21.9811 20.3447 24C20.3447 26.0189 21.9814 27.6556 24.0003 27.6556Z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 24.7311C24.4034 24.7311 24.7308 24.4038 24.7308 24C24.7308 23.5963 24.4034 23.2689 23.9997 23.2689C23.5959 23.2689 23.2686 23.5963 23.2686 24C23.2686 24.4038 23.5959 24.7311 23.9997 24.7311Z",
    fill: "#000088"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.875 22.5377L24.0003 20.3444L24.1257 22.5377L24.0003 23.5821L23.875 22.5377Z",
    fill: "#000088"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1257 25.4621L24.0004 27.6555L23.875 25.4621L24.0004 24.4177L24.1257 25.4621Z",
    fill: "#000088"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1611 22.7962L22.173 20.8341L23.3782 22.6709L23.7919 23.6381L23.1611 22.7962Z",
    fill: "#000088"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8404 25.2035L25.8286 27.1657L24.6234 25.3288L24.2097 24.3617L24.8404 25.2035Z",
    fill: "#000088"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1611 25.2034L22.173 27.1656L23.3782 25.3288L23.7919 24.3616L23.1611 25.2034Z",
    fill: "#000088"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8404 22.7961L25.8286 20.834L24.6234 22.6708L24.2097 23.638L24.8404 22.7961Z",
    fill: "#000088"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1601 25.2038L22.172 27.1659L23.3772 25.3291L23.7909 24.3619L23.1601 25.2038Z",
    fill: "#000088"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8395 22.7965L25.8276 20.8343L24.6224 22.6712L24.2087 23.6383L24.8395 22.7965Z",
    fill: "#000088"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 22.6199L24.9463 20.4689L24.2576 22.5551L24.1083 23.5964L24.4997 22.6199Z",
    fill: "#000088"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5007 25.3799L23.054 27.5309L23.7428 25.4447L23.892 24.4034L23.5007 25.3799Z",
    fill: "#000088"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4997 25.3799L24.9463 27.531L24.2576 25.4448L24.1083 24.4035L24.4997 25.3799Z",
    fill: "#000088"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5007 22.62L23.054 20.469L23.7428 22.5552L23.892 23.5964L23.5007 22.62Z",
    fill: "#000088"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4449 24.2572L27.531 24.9459L25.38 24.4993L24.4036 24.1079L25.4449 24.2572Z",
    fill: "#000088"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5552 23.7424L20.469 23.0537L22.6201 23.5003L23.5965 23.8917L22.5552 23.7424Z",
    fill: "#000088"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5561 24.2573L20.4699 24.946L22.621 24.4994L23.5974 24.108L22.5561 24.2573Z",
    fill: "#000088"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4458 23.7425L27.5319 23.0538L25.3809 23.5004L24.4045 23.8918L25.4458 23.7425Z",
    fill: "#000088"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.671 24.6226L20.8342 25.8278L22.7963 24.8397L23.6382 24.2089L22.671 24.6226Z",
    fill: "#000088"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.329 23.3775L27.1658 22.1723L25.2036 23.1604L24.3618 23.7911L25.329 23.3775Z",
    fill: "#000088"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8771 23.0545L21.4148 21.4149L23.0543 22.8772L23.7043 23.7044L22.8771 23.0545Z",
    fill: "#000088"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1223 24.9451L26.5846 26.5846L24.945 25.1223L24.2951 24.2952L25.1223 24.9451Z",
    fill: "#000088"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.671 23.3773L20.8342 22.1721L22.7963 23.1602L23.6381 23.791L22.671 23.3773Z",
    fill: "#000088"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.329 24.6224L27.1658 25.8276L25.2036 24.8395L24.3618 24.2087L25.329 24.6224Z",
    fill: "#000088"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0548 25.1227L21.4153 26.585L22.8776 24.9454L23.7047 24.2955L23.0548 25.1227Z",
    fill: "#000088"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9454 22.8775L26.585 21.4152L25.1227 23.0547L24.2955 23.7047L24.9454 22.8775Z",
    fill: "#000088"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3443 24.0695L22.5376 24.1949L23.582 24.0695L22.5376 23.9442L20.3443 24.0695Z",
    fill: "#000088"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6557 24.0695L25.4624 23.9442L24.418 24.0695L25.4624 24.1948L27.6557 24.0695Z",
    fill: "#000088"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6519 27.6401C24.6651 27.54 24.5946 27.4482 24.4946 27.435C24.3945 27.4218 24.3027 27.4923 24.2895 27.5923C24.2763 27.6924 24.3468 27.7842 24.4468 27.7974C24.5469 27.8106 24.6387 27.7401 24.6519 27.6401Z",
    fill: "#000088"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5728 27.3822C25.5859 27.2822 25.5155 27.1904 25.4154 27.1772C25.3154 27.164 25.2236 27.2345 25.2104 27.3345C25.1972 27.4346 25.2676 27.5264 25.3677 27.5396C25.4678 27.5528 25.5596 27.4823 25.5728 27.3822Z",
    fill: "#000088"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3726 26.9024C26.3858 26.8023 26.3153 26.7105 26.2153 26.6973C26.1152 26.6841 26.0234 26.7546 26.0102 26.8547C25.997 26.9548 26.0675 27.0466 26.1675 27.0597C26.2676 27.0729 26.3594 27.0025 26.3726 26.9024Z",
    fill: "#000088"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0611 26.2167C27.0743 26.1166 27.0038 26.0248 26.9037 26.0117C26.8037 25.9985 26.7118 26.0689 26.6987 26.169C26.6855 26.2691 26.7559 26.3609 26.856 26.3741C26.9561 26.3873 27.0479 26.3168 27.0611 26.2167Z",
    fill: "#000088"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5406 25.3987C27.5538 25.2986 27.4833 25.2068 27.3832 25.1937C27.2831 25.1805 27.1913 25.2509 27.1782 25.351C27.165 25.4511 27.2354 25.5429 27.3355 25.5561C27.4356 25.5693 27.5274 25.4988 27.5406 25.3987Z",
    fill: "#000088"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.812 24.5165C27.8252 24.4164 27.7547 24.3246 27.6547 24.3115C27.5546 24.2983 27.4628 24.3687 27.4496 24.4688C27.4365 24.5689 27.5069 24.6607 27.607 24.6739C27.707 24.6871 27.7988 24.6166 27.812 24.5165Z",
    fill: "#000088"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6519 20.3811C24.6651 20.4811 24.5946 20.573 24.4946 20.5861C24.3945 20.5993 24.3027 20.5289 24.2895 20.4288C24.2763 20.3287 24.3468 20.2369 24.4468 20.2237C24.5469 20.2105 24.6387 20.281 24.6519 20.3811Z",
    fill: "#000088"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5719 20.6387C25.5851 20.7388 25.5146 20.8306 25.4145 20.8438C25.3144 20.857 25.2226 20.7865 25.2094 20.6865C25.1962 20.5864 25.2667 20.4946 25.3668 20.4814C25.4669 20.4682 25.5587 20.5387 25.5719 20.6387Z",
    fill: "#000088"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3726 21.1186C26.3858 21.2187 26.3153 21.3105 26.2153 21.3237C26.1152 21.3369 26.0234 21.2664 26.0102 21.1663C25.997 21.0662 26.0675 20.9744 26.1675 20.9613C26.2676 20.9481 26.3594 21.0185 26.3726 21.1186Z",
    fill: "#000088"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0611 21.8044C27.0743 21.9045 27.0038 21.9963 26.9037 22.0095C26.8037 22.0226 26.7118 21.9522 26.6987 21.8521C26.6855 21.752 26.7559 21.6602 26.856 21.647C26.9561 21.6339 27.0479 21.7043 27.0611 21.8044Z",
    fill: "#000088"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5406 22.6223C27.5538 22.7223 27.4833 22.8142 27.3832 22.8273C27.2831 22.8405 27.1913 22.7701 27.1782 22.67C27.165 22.5699 27.2354 22.4781 27.3355 22.4649C27.4356 22.4517 27.5274 22.5222 27.5406 22.6223Z",
    fill: "#000088"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8121 23.5045C27.8253 23.6046 27.7548 23.6964 27.6547 23.7095C27.5546 23.7227 27.4628 23.6523 27.4496 23.5522C27.4365 23.4521 27.5069 23.3603 27.607 23.3471C27.7071 23.3339 27.7989 23.4044 27.8121 23.5045Z",
    fill: "#000088"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3618 27.6401C23.3486 27.54 23.419 27.4482 23.5191 27.435C23.6192 27.4218 23.711 27.4923 23.7242 27.5923C23.7374 27.6924 23.6669 27.7842 23.5668 27.7974C23.4668 27.8106 23.3749 27.7401 23.3618 27.6401Z",
    fill: "#000088"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4409 27.3822C22.4277 27.2822 22.4981 27.1904 22.5982 27.1772C22.6983 27.164 22.7901 27.2345 22.8033 27.3345C22.8165 27.4346 22.746 27.5264 22.6459 27.5396C22.5459 27.5528 22.454 27.4823 22.4409 27.3822Z",
    fill: "#000088"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6411 26.9024C21.6279 26.8023 21.6983 26.7105 21.7984 26.6973C21.8985 26.6841 21.9903 26.7546 22.0035 26.8547C22.0167 26.9548 21.9462 27.0466 21.8461 27.0597C21.746 27.0729 21.6542 27.0025 21.6411 26.9024Z",
    fill: "#000088"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9526 26.2167C20.9394 26.1166 21.0099 26.0248 21.1099 26.0117C21.21 25.9985 21.3018 26.0689 21.315 26.169C21.3282 26.2691 21.2577 26.3609 21.1577 26.3741C21.0576 26.3873 20.9658 26.3168 20.9526 26.2167Z",
    fill: "#000088"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4731 25.3987C20.4599 25.2986 20.5304 25.2068 20.6304 25.1937C20.7305 25.1805 20.8223 25.2509 20.8355 25.351C20.8487 25.4511 20.7782 25.5429 20.6782 25.5561C20.5781 25.5693 20.4863 25.4988 20.4731 25.3987Z",
    fill: "#000088"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2016 24.5165C20.1884 24.4164 20.2589 24.3246 20.359 24.3115C20.459 24.2983 20.5509 24.3687 20.564 24.4688C20.5772 24.5689 20.5068 24.6607 20.4067 24.6739C20.3066 24.6871 20.2148 24.6166 20.2016 24.5165Z",
    fill: "#000088"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3618 20.3811C23.3486 20.4811 23.419 20.573 23.5191 20.5861C23.6192 20.5993 23.711 20.5289 23.7242 20.4288C23.7374 20.3287 23.6669 20.2369 23.5668 20.2237C23.4668 20.2105 23.3749 20.281 23.3618 20.3811Z",
    fill: "#000088"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4409 20.6387C22.4277 20.7388 22.4981 20.8306 22.5982 20.8438C22.6983 20.857 22.7901 20.7865 22.8033 20.6865C22.8165 20.5864 22.746 20.4946 22.6459 20.4814C22.5459 20.4682 22.454 20.5387 22.4409 20.6387Z",
    fill: "#000088"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6411 21.1186C21.6279 21.2187 21.6983 21.3105 21.7984 21.3237C21.8985 21.3369 21.9903 21.2664 22.0035 21.1663C22.0167 21.0662 21.9462 20.9744 21.8461 20.9613C21.746 20.9481 21.6542 21.0185 21.6411 21.1186Z",
    fill: "#000088"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9526 21.8044C20.9394 21.9045 21.0099 21.9963 21.1099 22.0095C21.21 22.0226 21.3018 21.9522 21.315 21.8521C21.3282 21.752 21.2577 21.6602 21.1577 21.647C21.0576 21.6339 20.9658 21.7043 20.9526 21.8044Z",
    fill: "#000088"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4731 22.6223C20.4599 22.7223 20.5304 22.8142 20.6304 22.8273C20.7305 22.8405 20.8223 22.7701 20.8355 22.67C20.8487 22.5699 20.7782 22.4781 20.6782 22.4649C20.5781 22.4517 20.4863 22.5222 20.4731 22.6223Z",
    fill: "#000088"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2016 23.5045C20.1884 23.6046 20.2589 23.6964 20.359 23.7095C20.459 23.7227 20.5509 23.6523 20.564 23.5522C20.5772 23.4521 20.5068 23.3603 20.4067 23.3471C20.3066 23.3339 20.2148 23.4044 20.2016 23.5045Z",
    fill: "#000088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHindi);
export default __webpack_public_path__ + "static/media/Hindi.74027d57.svg";
export { ForwardRef as ReactComponent };